import React, { Fragment } from 'react';
import SEO from '../../components/SEO/SEO';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle'
import BlogList from '../../components/BlogList/BlogList.js'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';

import Logo from '../../images/Horizontal-Logo-white.png';

const BlogPageFullwidth = () => {
    return (
        <Fragment>
            <SEO
                title="Newsroom"
                description="Latest articles and updates from Pharmacy Freedom Fund on pharmacy investing, operations, and community healthcare."
                keywords={["pharmacy news", "healthcare blog", "pharmacy investing insights", "Pharmacy Freedom Fund newsroom"]}
                canonical="https://pharmacyfreedomfund.com/newsroom"
            />
            <Navbar hclass={'wpo-site-header wpo-site-header-s2'} Logo={Logo} />
            <PageTitle pageTitle={'Newsroom'} pagesub={'Articles'} />
            <BlogList blLeft={'d-none'} blRight={'col-lg-10 offset-lg-1'} />
            <Footer hclass={'wpo-site-footer'} />
            <Scrollbar />
        </Fragment>
    )
};
export default BlogPageFullwidth;

